<template>
  <dara-modal
    ref="modal"
    :title="$t('warning')"
    v-bind="$attrs"
    v-on="$listeners">
    <template #content>
      <div v-if="content !== null">
        {{ content }}
      </div>
    </template>
    <template #footer>
      <dara-button
        class="btn btn-success"
        size="sm"
        @click="confirm()">
        {{ $t('confirm') }}
      </dara-button>
    </template>
  </dara-modal>
</template>

<script>
export default {
  name: 'DaraModalConfirm',
  props: {
    closeAfterConfirm: {
      type: Boolean,
      default: true,
    },
    content: {
      type: String,
      default: null,
    },
  },
  methods: {
    confirm() {
      this.$emit('confirm');
      if (this.closeAfterConfirm) {
        this.$refs.modal.close();
      }
    },
  },
};
</script>
